import { ListResourcesResponseContent } from "@/requests/libraries/list-resources.request";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type ResourceListStoreState = {
  isPreviewDrawerOpen: boolean;
  resource: ListResourcesResponseContent | null;
};

type ResourceListStoreActions = {
  actions: {
    setIsPreviewDrawerOpen: (isOpen: boolean) => void;
    setResource: (resource: ListResourcesResponseContent | null) => void;
  };
};

type ResourceListStore = ResourceListStoreState & ResourceListStoreActions;

const defaultState: ResourceListStoreState = {
  isPreviewDrawerOpen: false,
  resource: null,
};

export const resourceListStore = create<ResourceListStore>()(
  devtools(
    (set) => ({
      ...defaultState,
      actions: {
        setIsPreviewDrawerOpen: (isOpen: boolean) => {
          set({ isPreviewDrawerOpen: isOpen });
        },
        setResource: (resource: ListResourcesResponseContent | null) => {
          set({ resource });
        },
      },
    }),
    {
      name: "resource-list-store",
      enabled: !import.meta.env.PROD,
    },
  ),
);

export const useResourceListIsPreviewDrawerOpen = () =>
  resourceListStore((state) => state.isPreviewDrawerOpen);

export const useResourceListResource = () =>
  resourceListStore((state) => state.resource);

export const useResourceListActions = () =>
  resourceListStore((state) => state.actions);
